// src/store/modules/landing-page.js
import { GET_EVENTS, GET_EVENT_DETAILS, UPDATE_EVENT } from '@/store/action-types';
import { SET_EVENTS, SET_EVENT_DETAILS } from '@/store/mutation-types';
import { GET_EVENT } from '@/store/getters-types';
import {  } from '@/store/getters-types';
import eventModel from '@/models/events/events'; 

export default {
  namespaced: true,
  actions: {

    async [GET_EVENTS]({ commit }) {
      commit(SET_EVENTS, await eventModel.getAll());
    },
    async [GET_EVENTS]({ commit }) {
      commit(SET_EVENTS, await eventModel.getAll());
    },
    async [GET_EVENT_DETAILS]({ commit }, { eventId }) {
      commit(SET_EVENT_DETAILS, await eventModel.getDetails(eventId));
    },
    async [UPDATE_EVENT]({ commit }, {eventId, event}) {
      await eventModel.update(eventId, event)
      commit(SET_EVENT_DETAILS, await eventModel.getDetails(eventId));
    },
  },
  mutations: {
    [SET_EVENTS](state, event) {
      state.events = { ...event };
    },
    [SET_EVENT_DETAILS](state, event) {
      state.currentEvent = { ...event };
    },
  },
  getters: {
    [GET_EVENT]: (state) => () => {
      if(state.currentEvent!=null){
        return state.currentEvent.event;
      }
      return null
    },
  },
  // We initialize the state with
  // an empty LandingPage object.
  state: {
    events: [],
    currentEvent: null
  },
};